import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { TranslationRepository } from '../../domain/repositories/translation.repository';
import { TranslationRepositoryImpl } from '../repositories/translation.repository.impl';
import { TRANSLATION_REPOSITORY_TOKEN } from '../../domain/tokens/injection.tokens';

/**
 * Dependency Injection Module
 * Configura las dependencias para el sistema de traducciones
 */
@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: TRANSLATION_REPOSITORY_TOKEN,
      useClass: TranslationRepositoryImpl
    }
  ]
})
export class TranslationModule { }
